import { Component, ViewChild, ElementRef } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { PaginationService } from 'src/app/PaginationService';
import { messageService } from 'src/app/message.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { qmsService } from '../qms.service';
import { EditorComponent } from 'src/app/editor/editor.component';
import { ExcelPdfComponent } from '../../support/excel-pdf/excel-pdf.component';

@Component({
  selector: 'app-vendor-details',
  templateUrl: './vendor-details.component.html',
  styleUrls: ['./vendor-details.component.scss']
})
export class VendorDetailsComponent {

  isProcessing = true;
  dateCustomClasses: DatepickerDateCustomClasses[];
  vendorDetails: any = {};
  vendorId: number;
  vendorName: string;
  selectedTabIndex: number;

  tabs = [{
    tab_icon: "fa-solid fa-book-open",
    tab_name: "All Audits"
  }, {
    tab_icon: "fa fa-calendar",
    tab_name: "Audits in Schedule Phase"
  }, {
    tab_icon: "fa fa-tasks",
    tab_name: "Audit in Plan Phase"
  }, {
    tab_icon: "fa-solid fa-bars-progress",
    tab_name: "Audit in Conduct Phase"
  }]

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef,
    public qmsService: qmsService) {

    const data: any = router.getCurrentNavigation()?.extras.state;
    this.vendorDetails = data.vendorDetails;
    this.vendorId = data.vendorDetails.VENDOR_ID;
    this.vendorName = data.vendorDetails.VENDOR_NAME;
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    this.message.breadcrumbData.fifthLevelFromDependency = 'Vendor Name : ' + this.vendorName;
  }

  ngOnInit() {
    this.selectedTabIndex = 0;
    this.getCall(this.selectedTabIndex);
  }

  ngOnDestroy() {
    this.message.breadcrumbData.fifthLevelFromDependency = '';
  }

  onTabChanged(e: any) {
    this.getCall(this.selectedTabIndex);
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  grid: any = [];
  gridTemp: any;
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';
  currentTableViewName: string = "";

  getCall(index: number) {
    this.isProcessing = true;

    const vendorMapping: { [key: number]: string | null } = {
      0: null, 1: 'Schedule', 2: 'Plan', 3: 'Conduct'
    };

    const gridMapping: { [key: number]: string | null } = {
      0: 'AU_CONDUCT', 1: 'AU_SCHEDULE', 2: 'AU_PLAN', 3: 'AU_CONDUCT'
    };

    setTimeout(() => { this.isProcessing = false; }, 3000);

    const data = {

      gridName: 'AU_CONDUCT',
      groupId: this.qmsService.selectedActivityGroupId.toString()
    }

    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause = response.orderByClause ? response.orderByClause : "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          gridName: "QMS_AU_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || "",
          groupId: this.qmsService.selectedActivityGroupId.toString(),
          isForVendorDetails: 'Y',
          vendorId: this.vendorId.toString(),
          auConditionForVendors: vendorMapping[index]
        }
        this.currentTableViewName = response.tableOrViewName ?? "",

          this.appService.getDynamicGridData(data1).subscribe({
            next: (response1: any) => {
              this.grid = response1;
              data1.columnsListarray = data1.columnsList.split(",");
              data1.fieldColumnarray = data1.fieldLabelsList.split(",");
              data1.invisibleColumnarray = data1.invisibleColumn.split(",");
              data1.fieldSizeListArray = data1.fieldSizeList.split(",");
              this.columnLists.columnsListarray = data1.columnsListarray;
              this.columnLists.fieldLabelsList = data1.fieldLabelsList;
              this.columnLists.fieldColumnarray = [];
              for (let p = 0; p < data1.fieldColumnarray.length; p++) {
                this.columnLists.fieldColumnarray.push({
                  "fieldColumnarray": data1.fieldColumnarray[p],
                  "width": data1.fieldSizeListArray[p] + 'px'
                })
              }
              this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
              this.columnLists.fieldSizeListArray = [];
              for (const element of data1.fieldSizeListArray) {
                this.columnLists.fieldSizeListArray.push(element + 'px');
              }
              for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
                for (const element of this.columnLists.invisibleColumnarray) {
                  if (this.columnLists.columnsListarray[y] == element) {
                    this.columnLists.columnsListarray.splice(y, 1);
                    this.columnLists.fieldColumnarray.splice(y, 1);
                    this.columnLists.fieldSizeListArray.splice(y, 1);
                  }
                }
              }
              let tableData = {
                tablename: data1.tableOrViewName
              };
              this.columnLists.columnsListarray1 = [];
              this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
                this.dataTypeList = response2;
                for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                  this.columnLists.columnsListarray1.push({});
                  this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                  this.columnLists.columnsListarray1[m].dataType = "textbox";
                  this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                  for (const element of this.dataTypeList) {
                    if (element.columnName == this.columnLists.columnsListarray[m]) {
                      this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                    }
                  }
                }
                for (const rowData of this.grid) {
                  for (const element of this.dataTypeList) {
                    if (element.fieldType === 'CHECKBOX') {
                      rowData[element.columnName] = rowData[element.columnName] === 'Y';
                    }
                  }
                }
                this.calculateTotalPages = this.collectionSize / this.perPage;
                this.pager.totalPages = undefined;
                this.setPage(1, 0);
              });
              this.message.gridList = this.grid;
              this.collectionSize = this.grid.length;
              this.totalPages = Math.ceil(this.grid.length / this.itemsPerPage);
              this.isProcessing = false;
            }, error: (error) => {
              this.isProcessing = false;
              throw error;
            }
          });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.grid.length, page, this.perPage, targetPage);
    this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.gridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.gridTemp.length, page, this.perPage, targetPage);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.grid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.gridTemp = this.grid;
      this.pager = this.paginationService.getPager(this.gridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.grid == undefined) {
        return this.grid;
      }
      if (!this.grid.length) {
        return this.grid;
      }
      if (filter != undefined) {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedOrSearch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.grid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssFunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  childCheckBox: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBox = true;
      for (const element of this.grid) {
        element.childCheckBox = true;
      }
    } else {
      this.childCheckBox = false;
      for (const element of this.grid) {
        element.childCheckBox = false;
      }
    }
  }

  previousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousSelectedValue != undefined) {
        this.grid[this.previousSelectedValue].childCheckBox = false;
      }
      list.childCheckBox = true;
    } else {
      list.childCheckBox = false;
    }
    this.previousSelectedValue = idx;
  }

  refreshGridData() {
    this.getCall(this.selectedTabIndex);
  }

  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  htmlContent: any;

  getClobData(list: any, columnName: any) {
    this.isProcessing = true;

    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: columnName
    }
    this.htmlContent = "";

    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (response: any) => {
        this.htmlContent = response;
        this.editorComponent.openEditor(this.htmlContent, columnName);
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  backToPreviousPage() {
    this.router.navigate(['dashboard/vendors']);
  }


  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};

  openReport(reportType: string) {
    let tableName = 'QMS_AU_VW';
    let dbCols: string[] = [];
    let reportLabels: string[] = [];

    if (this.columnLists && this.columnLists.fieldColumnarray && this.columnLists.columnsListarray) {
      for (let i = 0; i < this.columnLists.fieldColumnarray.length; i++) {
        if (this.columnLists.columnsListarray[i] && this.columnLists.fieldColumnarray[i]) {
          dbCols.push(this.columnLists.columnsListarray[i]);
          reportLabels.push(this.columnLists.fieldColumnarray[i].fieldColumnarray);
        }
      }
    }

    let dynamicWhere = `VENDOR_ID = '${this.vendorId}'`;

    switch (this.selectedTabIndex) {
      case 1:
        dynamicWhere += " AND STATUS LIKE '%Sch%'";
        break;
      case 2:
        dynamicWhere += " AND STATUS LIKE '%Pla%'";
        break;
      case 3:
        dynamicWhere += " AND STATUS NOT LIKE '%Pla%' AND STATUS NOT LIKE '%Sch%'";
        break;
      default:
        break;
    }

    this.excelPdf = {
      tableOrView_Name: tableName,
      columnList_DB: dbCols.join(','),
      columnList_Report: reportLabels.join(','),
      reportName: 'Vendor Audit Report',
      dropDown: reportLabels,
      reportType: 'Static',
      whereClause_Report: dynamicWhere
    };

    setTimeout(() => {
      if (this.excelPdfComponent) {
        this.excelPdfComponent.openReportPopup(reportType);
      } else {
        console.error("ExcelPdfComponent not found. Ensure the <app-excel-pdf> tag is at the bottom of the HTML.");
      }
    }, 100);
  }
}
